function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 0.704285C6.13261 0.704285 6.25979 0.755479 6.35355 0.846606C6.44732 0.937733 6.5 1.06133 6.5 1.1902V6.04936H11.5C11.6326 6.04936 11.7598 6.10055 11.8536 6.19168C11.9473 6.2828 12 6.4064 12 6.53527C12 6.66414 11.9473 6.78774 11.8536 6.87887C11.7598 6.96999 11.6326 7.02119 11.5 7.02119H6.5V11.8803C6.5 12.0092 6.44732 12.1328 6.35355 12.2239C6.25979 12.3151 6.13261 12.3663 6 12.3663C5.86739 12.3663 5.74021 12.3151 5.64645 12.2239C5.55268 12.1328 5.5 12.0092 5.5 11.8803V7.02119H0.5C0.367392 7.02119 0.240215 6.96999 0.146447 6.87887C0.0526785 6.78774 0 6.66414 0 6.53527C0 6.4064 0.0526785 6.2828 0.146447 6.19168C0.240215 6.10055 0.367392 6.04936 0.5 6.04936H5.5V1.1902C5.5 1.06133 5.55268 0.937733 5.64645 0.846606C5.74021 0.755479 5.86739 0.704285 6 0.704285Z"
});

function SvgIconPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#651A98",
    width: 16,
    height: 16,
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/iconPlus.7dcadedf.svg";
export { ForwardRef as ReactComponent };